// React libraries
import React from "react";
// Component Styles
import { useStyles } from "./EmptyChartDataStyles";
// Material UI Core
import Grid from '@mui/material/Grid';
// Icon
import NoChart from "../../icons/NoChart/NoChart";
export const EmptyChartData = (props) => {
    const classes = useStyles(props);
    const { id, style, textNoChartContent, textNoChartContentSmall, } = props;
    return (React.createElement("div", { style: style, id: id },
        React.createElement(Grid, { container: true, alignItems: "center", justifyContent: "center", className: classes.noChartWrapper },
            React.createElement(Grid, { item: true, md: 12 },
                React.createElement(Grid, { container: true },
                    React.createElement(Grid, { item: true, md: 12, container: true, justifyContent: "center", alignItems: "center" },
                        React.createElement(NoChart, { className: classes.noChartIcon })),
                    React.createElement(Grid, { item: true, md: 12, container: true, justifyContent: "center", alignItems: "center" },
                        React.createElement(Grid, { container: true },
                            React.createElement(Grid, { item: true, md: 12, container: true, justifyContent: "center", alignItems: "center" },
                                React.createElement("span", { className: classes.noChartContent }, textNoChartContent))),
                        React.createElement(Grid, { item: true, md: 12, container: true, justifyContent: "center", alignItems: "center" },
                            React.createElement("span", { className: classes.noChartContentSmall }, textNoChartContentSmall))))))));
};
EmptyChartData.defaultProps = {
    textNoChartContent: "Not enough data to show",
    textNoChartContentSmall: "Please use our system for at least a month to see your first monthly chart",
};
export default React.memo(EmptyChartData);
